import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const UIContext = createContext();

// Holds purely-UI state (e.g. sidebar collapse) separate from GlobalContext.
// Keeping it isolated means toggling the sidebar only re-renders the layout
// shell and Sidebar — NOT every data page that consumes useGlobal(), so list
// pages don't re-fire their fetch effects on expand/collapse.
export const UIProvider = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const toggleSidebar = useCallback(() => {
    setIsSidebarCollapsed((prev) => !prev);
  }, []);

  const value = {
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    toggleSidebar,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUI must be used within a UIProvider");
  }
  return context;
};
